export const ru = {
    'empty-custom-period': 'Укажите количество дней',
    'empty-shows-limit': 'Укажите частоту показов'
};
